__turbopack_context__.v({
  "bz-app-0": "ContentCard-module-scss-module__4-ap6q__bz-app-0",
  "bz-app-1": "ContentCard-module-scss-module__4-ap6q__bz-app-1",
  "bz-app-2": "ContentCard-module-scss-module__4-ap6q__bz-app-2",
  "bz-refund-0": "ContentCard-module-scss-module__4-ap6q__bz-refund-0",
  "bz-refund-1": "ContentCard-module-scss-module__4-ap6q__bz-refund-1",
  "bz-refund-2": "ContentCard-module-scss-module__4-ap6q__bz-refund-2",
});
